// Supermove
import {gql} from '@supermove/graphql';
import {MutationError, useForm, useFormMutation} from '@supermove/hooks';
import {Phone} from '@supermove/utils';

// App
import UpdateProjectSinglePropertyForm, {
  UpdateProjectSinglePropertyFormFields,
} from '@shared/modules/Project/forms/UpdateProjectSinglePropertyForm';

const useUpdateProjectClientContactPhoneNumberMutation = ({
  updateProjectSinglePropertyForm,
  onSuccess,
  onError,
}: {
  updateProjectSinglePropertyForm: UpdateProjectSinglePropertyFormFields;
  onSuccess: () => void;
  onError: (error: MutationError[]) => void;
}) => {
  const form = useForm({
    initialValues: {
      updateProjectSinglePropertyForm,
    },
  });

  const {submitting, handleSubmit} = useFormMutation({
    form,
    mutation: useUpdateProjectClientContactPhoneNumberMutation.mutation,
    variables: {
      updateProjectSinglePropertyForm: UpdateProjectSinglePropertyForm.toMutation({
        ...form.values.updateProjectSinglePropertyForm,
        stringValue: Phone.strip(form.values.updateProjectSinglePropertyForm.stringValue ?? ''),
      }),
    },
    onSuccess,
    onError,
  });

  return {
    form,
    submitting,
    handleSubmit,
  };
};

// --------------------------------------------------
// Data
// --------------------------------------------------
useUpdateProjectClientContactPhoneNumberMutation.mutation = gql`
  mutation UpdateProjectClientContactPhoneNumberMutation($updateProjectSinglePropertyForm: UpdateProjectSinglePropertyForm) {
    response: updateProjectClientContactPhoneNumber(updateProjectSinglePropertyForm: $updateProjectSinglePropertyForm) {
      ${gql.errors}
      project {
        id
        client {
            id
            primaryContact {
                id
                phoneNumber
            }
        }
      }
    }
  }
`;

export default useUpdateProjectClientContactPhoneNumberMutation;
